import { useEffect, useState } from 'react'
import Cookies from '@arsenal/arsenal/modules/Cookies'
import { VERSION_COOKIE_KEY, NEW_VERSION } from 'lib/version'

export const isNewVersion = () => {
  if (typeof window === 'undefined') {
    return false
  }
  return Cookies(VERSION_COOKIE_KEY) === NEW_VERSION
}

export const getVersionHash = () => {
  if (isNewVersion()) {
    return `${VERSION_COOKIE_KEY}=${NEW_VERSION}`
  }
  return ''
}

// 如果是新版首页需要的url上添加#tt_web_version=new
export const addVersionToFeedback = () => {
  const hash = getVersionHash()
  if (hash) {
    setTimeout(() => {
      window.location.hash = hash
    }, 800) // 避免a标签里面 #!
  }
}

// 是否为pc3.0新版本
function useVersion() {
  const [isNew, setIsNew] = useState(false)

  useEffect(() => {
    const isNew = isNewVersion()
    setIsNew(isNew)
  }, [])

  return isNew
}

export default useVersion
